/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetMiscRandomnumberRequest = {
  min?: number | undefined;
  max?: number | undefined;
  count?: number | undefined;
  allow_repeat?: boolean | undefined;
  allow_decimal?: boolean | undefined;
  decimal_places?: number | undefined;
};

export const GetMiscRandomnumberRequest$zodSchema: z.ZodType<
  GetMiscRandomnumberRequest
> = z.object({
  allow_decimal: z.boolean().default(false).describe(
    "是否生成小（浮点）数。如果为 false，则只生成整数。",
  ),
  allow_repeat: z.boolean().default(false).describe(
    "是否允许生成的多个数字中出现重复值。",
  ),
  count: z.int().default(1).describe("需要生成的随机数的数量。"),
  decimal_places: z.int().default(2).describe(
    "如果 `allow_decimal=true`，这里可以指定小数的位数。",
  ),
  max: z.int().default(100).describe("生成随机数的最大值（包含）。"),
  min: z.int().default(1).describe("生成随机数的最小值（包含）。"),
});

export type GetMiscRandomnumberDetails = {};

export const GetMiscRandomnumberDetails$zodSchema: z.ZodType<
  GetMiscRandomnumberDetails
> = z.object({});

/**
 * 请求参数无效。例如，`min` 大于 `max`，或者在不允许重复的情况下，请求的数量大于可能生成的数字总数。
 */
export type GetMiscRandomnumberBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetMiscRandomnumberDetails | undefined;
  message?: string | undefined;
};

export const GetMiscRandomnumberBadRequestResponseBody$zodSchema: z.ZodType<
  GetMiscRandomnumberBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetMiscRandomnumberDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "请求参数无效。例如，`min` 大于 `max`，或者在不允许重复的情况下，请求的数量大于可能生成的数字总数。",
);

/**
 * 生成成功！返回一个包含随机数的数组。
 */
export type GetMiscRandomnumberResponseBody = {
  numbers?: Array<number> | undefined;
};

export const GetMiscRandomnumberResponseBody$zodSchema: z.ZodType<
  GetMiscRandomnumberResponseBody
> = z.object({
  numbers: z.array(z.number()).optional(),
}).describe("生成成功！返回一个包含随机数的数组。");

export type GetMiscRandomnumberResponse =
  | GetMiscRandomnumberResponseBody
  | GetMiscRandomnumberBadRequestResponseBody;

export const GetMiscRandomnumberResponse$zodSchema: z.ZodType<
  GetMiscRandomnumberResponse
> = z.union([
  z.lazy(() => GetMiscRandomnumberResponseBody$zodSchema),
  z.lazy(() => GetMiscRandomnumberBadRequestResponseBody$zodSchema),
]);
